import { AccountsAPI } from "api/axios.config";

const BASE_URL = "/Postings";


export const createJournalPosting = async (data) => {
  return await AccountsAPI.post(BASE_URL, JSON.stringify({ data }), {
    headers: { "Content-Type": "application/json" },
  });
};


export const getOfficeCreditMatterList = async (matterId) => {
  const response = await AccountsAPI.get(`${BASE_URL}/Matters/${matterId}/UnpaidSales`);
  return response.data?.data || [];
};

export const getPostingDetails = async (id) => {
  const response = await AccountsAPI.get(`${BASE_URL}/${id}`);
  return response.data?.data;
};

export const getMattersBalances = async (matterId) => {
  const response = await AccountsAPI.get(`${BASE_URL}/Matters/${matterId}/Balances`);
  return response.data?.data || response.data;
};

export const getMattersPostings = async (matterId, type) => {
  const response = await AccountsAPI.get(`${BASE_URL}/Matters/${matterId}?LedgerPostingType=${type}`);
  return response.data?.data;
};
